<template>
  <div>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="jobName" @click="$emit('resetJobName')">
      <close-icon class="h6 mb-0 mr-1" /> {{ jobName }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedStates" :for="state" v-for="state in selectedStates">
      <close-icon class="h6 mb-0 mr-1" /> {{ states.find(stateData => stateData.abbr == state).name }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedStore" @click="$emit('resetStore')">
      <close-icon class="h6 mb-0 mr-1" />Filial {{ selectedStore }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedStoreCity" @click="$emit('resetStore')">
      <close-icon class="h6 mb-0 mr-1" />{{ selectedStoreCity }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedNeighborhoods" @click="$emit('resetStore')">
      <close-icon class="h6 mb-0 mr-1" />{{ selectedNeighborhoods }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedZipCode" @click="$emit('resetStore')">
      <close-icon class="h6 mb-0 mr-1" />{{ selectedZipCode }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedCities" :for="city" v-for="city in selectedCities">
      <close-icon class="h6 mb-0 mr-1" />{{ city }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedTeam && !this.$route.params.teamName" @click="$emit('resetTeam')">
      <close-icon class="h6 mb-0 mr-1" />{{ selectedTeam }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedLevel" @click="$emit('resetLevel')">
      <close-icon class="h6 mb-0 mr-1" />{{ levels.find((lv) => lv.id == selectedLevel)['name'] }}
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedPCD && !$route.query.pcd" for="pcd" >
      <close-icon class="h6 mb-0 mr-1" />PCD
    </label>

    <label class="badge badge-pill badge-blue-ml mx-1 font-weight-normal p-2 d-inline-flex align-items-center" v-if="selectedTemporary" for="temporary">
      <close-icon class="h6 mb-0 mr-1" />Temporário
    </label>

  </div>
</template>

<script>
  import CloseIcon from "vue-material-design-icons/Close.vue"

  export default {
    name: 'FiltersBadges',

    props: {
      jobName: String,
      selectedStates: Array,
      selectedStore: String,
      selectedStoreCity: String,
      selectedNeighborhoods: String,
      selectedZipCode: String,
      selectedCities: Array,
      selectedTeam: String,
      selectedLevel: String,
      selectedPCD: Boolean,
      selectedTemporary: Boolean
    },

    computed: {
      states(){
        return this.$store.state.domains.states;
      },

      levels(){
        let levels = this.$store.state.levels || [];
        return this.$helpers.sortBy(levels, 'name', 'asc');
      },
    },

    components: {
      CloseIcon
    }
  }
</script>

<style lang="scss" scoped>
  .badge{
    border-top-left-radius: 3rem;
  }
</style>